import React, { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import Gateway from "./Gateway";
import ReactSwitch from "react-switch";

import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { BallTriangle } from 'react-loader-spinner'
import { apiRequest } from "../../store/allApi";

export const Sitesettings = () => {
  
  const [checked, setChecked] = useState(true);
  const [checked1, setChecked1] = useState(true);
  const [checked2, setChecked2] = useState(true);
  const [checked3, setChecked3] = useState(true);
  const [checked0, setChecked0] = useState(true);
  const [checked4, setChecked4] = useState(true);
  const [checked5, setChecked5] = useState(true);
  const [checked6, setChecked6] = useState(true);

  const [checkedRoom, setCheckedRoom] = useState(true);
  const [checkedRoom1, setCheckedRoom1] = useState(true);
  const [checkedRoom2, setCheckedRoom2] = useState(true);
  const [checkedRoom3, setCheckedRoom3] = useState(true);
  const [checkedRoom4, setCheckedRoom4] = useState(true);

  const [checkedGame, setCheckedGame] = useState(true);
  const [isBots, setBots] = useState(true);
  const [checkedCommison, setCheckedCommision] = useState(true);

  const [checkedDeposit, setCheckedDeposit] = useState(true);

  const [checkedWithdrawal, setCheckedWithdrawal] = useState(true);
  const [checkedUpiWithdrawal, setCheckedUpiWithdrawal] = useState(true);
  const [checkedQrWithdrawal, setCheckedQrWithdrawal] = useState(true)
  const [checkedBankWithdrawal, setCheckedBankWithdrawal] = useState(true);

  const [checkedSupport, setCheckedSupport] = useState(true);

  const [checkedLogin, setCheckedLogin] = useState(true);
  const [checkedMaintenance, setCheckedMaintenance] = useState(true);
  const [onlineKYC, setonlineKYC] = useState(true);
  const [offlineKYC, setofflineKYC] = useState(true);
  const [checkedsignup, setCheckedsignup] = useState(true);

  const [checkedRoomCode, setCheckedRoomCode] = useState(true);
  const [isLudokingClassic, setLudoClassic] = useState(true);
  const [tijjrclassic, setTijjrClassic] = useState(true);
  const [tijjrOneGoti, setTijjrOneGoti] = useState(true);
  const [tijjrTwoGoti, setTijjrTwoGoti] = useState(true);
  const [tijjrSpeedLudo, setTijjrSpeedLudo] = useState(true);
  const [tijjrLudo, setTijjLudo] = useState(true);

  // Api
  const [ludokingroomcodeURL, SetLudokingroomcodeURL] = useState("");
  const [ludokingPopularroomcodeURL, SetLudokingPopularroomcodeURL] =
    useState("");
  const [ludokingHostroomcodeURL, SetLudokingHostroomcodeURL] = useState("");
  const [ludoking1GroomcodeURL, SetLudoking1GroomcodeURL] = useState("");
  const [ludokingSnakeroomcodeURL, SetLudokingSnakeroomcodeURL] = useState("");
  const [depositlimitMin, setDepositMin] = useState("");
  const [depositlimitMax, setDepositMax] = useState("");
  const [depositKyc, setDepositKyc] = useState("");
  const [newUserDeposit, setnewDeposit] = useState("");
  const [gameTDS, setGameTDS] = useState("");
  const [totalBotsCount, settotalBotsCount] = useState('');
  const [gameLimitMin, setGameLImitMin] = useState("");
  const [gameLimitMax, setGameLImitMax] = useState("");
  const [conflictRedTime, setconflictRedTime] = useState(10);
  const [withdrawRedTime, setwithdrawRedTime] = useState(10);
  const [referralCommission, setReferralCommission] = useState(0);
  const [lossReferralCommission, setLReferralCommission] = useState(0);
  const [commissionRange1, setCommissionRange1] = useState("");
  const [commissionRange2, setCommissionRange2] = useState("");
  const [commissionRange3, setCommissionRange3] = useState("");
  const [withdrawalLimitMin, setWithdrawalMin] = useState("");
  const [withdrawalLimitMax, setWithdrawalMax] = useState("");
  const [withdrawalLimitMinUpi, setWithdrawalUpiMin] = useState("");
  const [withdrawalLimitMaxUpi, setWithdrawalUpiMax] = useState("");
  const [withdrawalLimitMinBank, setWithdrawalBankMin] = useState("");
  const [withdrawalLimitMaxBank, setWithdrawalBankMax] = useState("");
  const [withdrawQrLimitMin, setWithdrawalQrMin] = useState("");
  const [withdrawQrLimitMax, setWithdrawalQrMax] = useState("");
  const [autoWithdrawalLimitMax, setautoWithdrawalMax] = useState("");
  const [withdrawTime, setWithdrawTime] = useState("");
  const [supportMail, setSupportMail] = useState("");
  const [supportInstagram, setSupportInstagram] = useState("");
  const [supportTelegram, setSupportTelegram] = useState("");
  const [supportWhatsapp, setSupportWhatsapp] = useState("");
  // alert(supportWhatsapp)
  const [ludokingClassic, setLudokingClassicImage] = useState("");
  const [ludokingHost, setLudokingHostImage] = useState("");
  const [ludokingPopular, setLudokingPopularImage] = useState("");
  const [ludoking1G, setLudoking1GImage] = useState("");
  const [ludokingSnake, setLudokingSnakeImage] = useState("");
  const [rkludoClassic, setRkludoClassicImage] = useState("");
  const [rkludoPopular, setRkludoPopularImage] = useState("");
  const [rkludo1G, setRkludo1GImage] = useState("");

  const [WebTitle, setWebTitle] = useState("");
  const [WebsiteName, setWebName] = useState("");
  const [CompanyName, setCompanyName] = useState("");
  const [CompanyAddress, setCompanyAddress] = useState("");
  const [CompanyMobile, setCompanyMobile] = useState("");
  const [Logo, setLogo] = useState("");
  const [site_message, setSite_message] = useState("");
  const [maintenence_msg, setMaintenence_msg] = useState("");
  const [withdraw_message, setWithdraw_message] = useState("");
  const [withdraw_messageOff, setWithdraw_messageOff] = useState("");
  const [deposit_message, setDeposit_message] = useState("");
  const [deposit_message_on, setdeposit_message_on] = useState("");
  const [ludoClassicAutoMsg, setLudoClassicAutoMsg] = useState("");
  const [ludoClassicAutobattleMsg, setLudoClassicAutobattleMsg] = useState("");
  const [site_viewManual, setSite_viewManual] = useState("");
  const [site_viewManualBattle, setSite_viewManualBattle] = useState("");

  const [version, setVersion] = useState("");

  const [settingId, setSettingId] = useState("");

  const [loader, setLoader] = useState(false);

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }

  const mydata =async () => {
    setLoader(true);
    const access_token = localStorage.getItem('token');
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
     try {
          const res = await apiRequest(`settings/data`,"GET", null,headers)
         if (res.data) {
               setLoader(false);
       console.log(res.data);
       setSettingId(res.data._id ? res.data._id : "");
       setWebTitle(res.data.WebTitle);
       setWebName(res.data.WebsiteName);
       setCompanyName(res.data.CompanyName);
       setCompanyAddress(res.data.CompanyAddress);
       setCompanyMobile(res.data.CompanyMobile);
       setSite_message(res.data.site_message);
       setMaintenence_msg(res.data.maintenence_msg);
       setWithdraw_message(res.data.withdraw_message);
       setWithdraw_messageOff(res.data.withdraw_messageOff);
       setDeposit_message(res.data.deposit_message);
       setdeposit_message_on(res.data.deposit_message_on);
       setLudoClassicAutoMsg(res.data.ludoClassicAutoMsg);
       setLudoClassicAutobattleMsg(res.data.ludoClassicAutobattleMsg);
       setSite_viewManual(res.data.ludoClassicManualMsg);
       setSite_viewManualBattle(res.data.ludoClassicManualBattleMsg);
       setLogo(res.data.Logo);
       setCheckedRoomCode(res.data.roomcode);
    
       setChecked(res.data.isLudokingClassic);
       setChecked1(res.data.isLudokingPopular);
       setChecked0(res.data.isLudokingSnake);
      
 
 
       setCheckedCommision(res.data.isReferral);
 
       setCheckedGame(res.data.gameSearch);
       setBots(res.data.isBots);
       setCheckedDeposit(res.data.isDeposit);
 
       setCheckedWithdrawal(res.data.isWithdrawal);
       setCheckedUpiWithdrawal(res.data.isUpiWithdrawal);
      setCheckedQrWithdrawal(res.data.isQrWithdrawal)

       setCheckedBankWithdrawal(res.data.isBankWithdrawal);
 
       setCheckedSupport(res.data.isChatSupport);
 
       setCheckedLogin(res.data.userCanLogin);
 
       setCheckedMaintenance(res.data.siteMaintenance);
       setonlineKYC(res.data.onlineKYC);
       setofflineKYC(res.data.offlineKYC);
       setCheckedsignup(res.data.userSignup);
       setLudoClassic(res.data.isLudokingClassic);
       setTijjrClassic(res.data.tijjrClassic);
       setTijjrOneGoti(res.data.tijjrOneGoti);
       setTijjrTwoGoti(res.data.tijjrTwoGoti);
       setTijjrSpeedLudo(res.data.tijjrSpeedLudo);
       setTijjLudo(res.data.tijjrLudo);
 
       setVersion(res.data.version);
       SetLudokingroomcodeURL(res.data.ludokingroomcodeURL);
       SetLudokingPopularroomcodeURL(res.data.ludokingPopularroomcodeURL);
       SetLudokingHostroomcodeURL(res.data.ludokingHostroomcodeURL);
       SetLudoking1GroomcodeURL(res.data.ludoking1GroomcodeURL);
       SetLudokingSnakeroomcodeURL(res.data.ludokingSnakeroomcodeURL);
       setDepositMin(res.data.depositlimitMin);
       setDepositMax(res.data.depositlimitMax);
       setDepositKyc(res.data.depositKyc);
       setnewDeposit(res.data.newUserDeposit);
       setGameTDS(res.data.gameTDS);
       settotalBotsCount(res.data.totalBotsCount);
       setGameLImitMin(res.data.gameLimitMin);
       setGameLImitMax(res.data.gameLimitMax);
       setconflictRedTime(res.data.conflictRedTime);
       setwithdrawRedTime(res.data.withdrawRedTime);
       setReferralCommission(res.data.referralCommission);
       setLReferralCommission(res.data.lossReferralCommission);
       setCommissionRange1(res.data.commissionRange1);
       setCommissionRange2(res.data.commissionRange2);
       setCommissionRange3(res.data.commissionRange3);
       setWithdrawalMin(res.data.withdrawalLimitMin);
       setWithdrawalMax(res.data.withdrawalLimitMax);
       setWithdrawalUpiMin(res.data.withdrawalLimitMinUpi);
       setWithdrawalUpiMax(res.data.withdrawalLimitMaxUpi);
       setWithdrawalBankMin(res.data.withdrawalLimitMinBank);
       setWithdrawalBankMax(res.data.withdrawalLimitMaxBank);
       setWithdrawalQrMin(res.data.withdrawQrLimitMin);
       setWithdrawalQrMax(res.data.withdrawQrLimitMax);
       setautoWithdrawalMax(res.data.autoWithdrawalLimitMax);
       setWithdrawTime(res.data.withdrawTime);
       setSupportMail(res.data.supportMail);
       setSupportInstagram(res.data.supportInstagram);
       setSupportTelegram(res.data.supportTelegram);
       setSupportWhatsapp(res.data.whatsappSupport);
     
         }
            } catch (e) {
              setLoader(false);

            }
            finally {
            }
  }

  useEffect(() => {
    mydata()
  }, []);

  // const handleSubmit1 = (e) => {
  //   e.preventDefault();
  //   formData.append("isLudokingroomcode", checkedRoom);

  // }

  const handleSubmit = async (e) => {
    e.preventDefault();
    let formData = new FormData();
    formData.append("settingId", settingId);
    formData.append("WebTitle", WebTitle);
    formData.append("WebsiteName", WebsiteName);
    formData.append("CompanyName", CompanyName);
    formData.append("CompanyAddress", CompanyAddress);
    formData.append("CompanyMobile", CompanyMobile);
    // formData.append("Logo", Logo);
    formData.append("version", version);
    formData.append("site_message", site_message);
    formData.append("maintenence_msg", maintenence_msg);
    formData.append("withdraw_message", withdraw_message);
    formData.append("withdraw_messageOff", withdraw_messageOff);
    formData.append("deposit_message", deposit_message);
    formData.append("deposit_message_on", deposit_message_on);
    formData.append("ludoClassicAutoMsg", ludoClassicAutoMsg);
    formData.append("ludoClassicAutobattleMsg", ludoClassicAutobattleMsg);
    formData.append("ludoClassicManualMsg", site_viewManual);
    formData.append("ludoClassicManualBattleMsg", site_viewManualBattle);

    formData.append("gameTDS", gameTDS);
    formData.append("totalBotsCount", totalBotsCount);
    formData.append("gameLimitMin", gameLimitMin);
    formData.append("gameLimitMax", gameLimitMax);
    formData.append("conflictRedTime", conflictRedTime);
    formData.append("withdrawRedTime", withdrawRedTime);
    formData.append("roomcode", checkedRoomCode);

    formData.append("referralCommission", referralCommission);
    formData.append("lossReferralCommission", lossReferralCommission);
    formData.append("commissionRange1", commissionRange1);
    formData.append("commissionRange2", commissionRange2);
    formData.append("commissionRange3", commissionRange3);

    formData.append("depositlimitMin", depositlimitMin);
    formData.append("depositlimitMax", depositlimitMax);
    formData.append("depositKyc", depositKyc);
    formData.append("newUserDeposit", newUserDeposit);

    formData.append("withdrawalLimitMin", withdrawalLimitMin);
    formData.append("withdrawalLimitMax", withdrawalLimitMax);
    formData.append("withdrawalLimitMinUpi", withdrawalLimitMinUpi);
    formData.append("withdrawalLimitMaxUpi", withdrawalLimitMaxUpi);
    formData.append("withdrawalLimitMinBank", withdrawalLimitMinBank);
    formData.append("withdrawalLimitMaxBank", withdrawalLimitMaxBank);
    formData.append("withdrawQrLimitMin", withdrawQrLimitMin);
    formData.append("withdrawQrLimitMax", withdrawQrLimitMax);
    formData.append("autoWithdrawalLimitMax", autoWithdrawalLimitMax);
    formData.append("withdrawTime", withdrawTime);

    formData.append("supportMail", supportMail);
    formData.append("supportInstagram", supportInstagram);
    formData.append("supportTelegram", supportTelegram);
    formData.append("supportWhatsapp", supportWhatsapp);
    // formData.append("isLudokingClassic", checked);
    // formData.append("isLudokingPopular", checked1);
    // formData.append("isLudokingSnake", checked0);
  


    formData.append("gameSearch", checkedGame);
    formData.append("isBots", isBots);
    formData.append("isReferral", checkedCommison);

    formData.append("isDeposit", checkedDeposit);

    // formData.append("isWithdrawal", checkedWithdrawal);
    formData.append("isUpiWithdrawal", checkedUpiWithdrawal);
    formData.append('isQrWithdrawal', checkedQrWithdrawal)

    formData.append("isBankWithdrawal", checkedBankWithdrawal);

    formData.append("isChatSupport", checkedSupport);

    formData.append("userCanLogin", checkedLogin);
    formData.append("siteMaintenance", checkedMaintenance);
    formData.append("onlineKYC", onlineKYC);
    formData.append("offlineKYC", offlineKYC);
    formData.append("userSignup", checkedsignup);
    formData.append("isLudokingClassic", isLudokingClassic);
    formData.append("tijjrClassic", tijjrclassic);
    formData.append("tijjrOneGoti", tijjrOneGoti);
    formData.append("tijjrTwoGoti", tijjrTwoGoti);
    formData.append("tijjrSpeedLudo", tijjrSpeedLudo);
    formData.append("tijjrLudo", tijjrLudo);

    formData.append("whatsappSupport", supportWhatsapp);

   
   

    const access_token = localStorage.getItem('token');
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    // let config = {
    //   method: "post",
    //   maxBodyLength: Infinity,
    //   url: baseUrl + `settings`,
    //   headers: {
    //     Authorization: `Bearer ${access_token}`,
    //   },
    //   data: formData,
    // };
    // const response = await axios.request(config);
    // console.log(response.data.status);
    // if (response.data.status === "success") {
    //   alert("Settings submitted successfully");
    // } else {
    //   alert("Settings Not Submitted");
    // }
     try {
          const res = await apiRequest(`settings`,"POST",  formData,headers)
         if (res.data) {
          if (res.data.status === "success") {
              alert("Settings submitted successfully");
            } else {
              alert("Settings Not Submitted");
            }
         }
            } catch (e) {
              // setLoading(false);
            }
            finally {
            }
  };

  useEffect(() => {
    const Logo1 = document.getElementById("Logo");

    Logo1.onchange = (e) => {
      const [file] = Logo1.files;
      setLogo(file);
    };
  
  }, []);

  const handleChange = (val) => {
    setChecked(val);
  };
  const handleChange1 = (val) => {
    setChecked1(val);
  };
  const handleChange2 = (val) => {
    setChecked2(val);
  };
  const handleChange3 = (val) => {
    setChecked3(val);
  };
  const handleChange0 = (val) => {
    setChecked0(val);
  };
  const handleChange4 = (val) => {
    setChecked4(val);
  };
  const handleChange5 = (val) => {
    setChecked5(val);
  };
  const handleChange6 = (val) => {
    setChecked6(val);
  };

  const handleChangeRoom = (val) => {
    setCheckedRoom(val);
  };
  const handleChangeRoom1 = (val) => {
    setCheckedRoom1(val);
  };
  const handleChangeRoom2 = (val) => {
    setCheckedRoom2(val);
  };
  const handleChangeRoom3 = (val) => {
    setCheckedRoom3(val);
  };
  const handleChangeRoom4 = (val) => {
    setCheckedRoom4(val);
  };

  const handleChangeGame = (val) => {
    setCheckedGame(val);
  };

  const handleBots = (val) => {
    setBots(val);
  };

  const handleChangeRoomCode = (val) => {
    setCheckedRoomCode(val);
  };

  const handleChangeCommison = (val) => {
    setCheckedCommision(val);
  };

  const handleChangeDeposit = (val) => {
    setCheckedDeposit(val);
  };

  const handleChangeWithdrawal = (val) => {
    setCheckedWithdrawal(val);
  };
  const handleChangeUpiWithdrawal = (val) => {
    setCheckedUpiWithdrawal(val);
  };
  const handleChangeQrWithdrawal = val => {
    setCheckedQrWithdrawal(val)
  }
  const handleChangeBankWithdrawal = (val) => {
    setCheckedBankWithdrawal(val);
  };

  const handleChangeSupport = (val) => {
    setCheckedSupport(val);
  };

  const handleChangeLogin = (val) => {
    setCheckedLogin(val);
  };

  const handleChangeMaintenance = (val) => {
    setCheckedMaintenance(val);
  };
  const handleChangeonlineKYC = (val) => {
    setonlineKYC(val);
  };
  const handleChangeofflineKYC = (val) => {
    setofflineKYC(val);
  };
  const handleChangeSignUp = (val) => {
    setCheckedsignup(val);
  };
  const handleLudoClassic = (val) => {
    setLudoClassic(val);
  };
  const handleTijjrClassic = (val) => {
    setTijjrClassic(val);
  };
  const handleTijjrOneGoti = (val) => {
    setTijjrOneGoti(val);
  };
  const handleTijjrTwoGoti = (val) => {
    setTijjrTwoGoti(val);
  };
  const handleTijjrSpeed = (val) => {
    setTijjrSpeedLudo(val);
  };
  const handleTijjrLudo = (val) => {
    setTijjLudo(val);
  };

  return loader  ? (
    <>
      <div className='App'>
        <div className='item dashboaed_loader'>
        <BallTriangle
  height={100}
  width={100}
  radius={5}
  color="#4fa94d"
  ariaLabel="ball-triangle-loading"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  />
        </div>
      </div>
    </>
  ) : (
    <>
      <div className="card mt-5">
        <div className="card-body  table_bg">
          <h4 className="dashboard_heading my-3">Website Settings</h4>
          <form
            onSubmit={handleSubmit}
            method="patch"
            encType="multipart/form-data"
            // style={{ backgroundColor: 'rgba(0, 27, 11, 0.734)' }}
          >
            <div className="form-row">
            <div className="form-group col-md-6">
                <Card>
                  <Card.Body>
                    <h4 className="dashboard_small_heading_blue">
                      Referral/commison
                    </h4>
                    <Container>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={8}>Referral</Col>
                        <Col sm={2}>
                          {" "}
                          <ReactSwitch
                            checked={checkedCommison}
                            onChange={handleChangeCommison}
                            style={{ display: "none" }}
                          />
                        </Col>
                      </Row>

                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={8}>Referral Commission Win</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            value={referralCommission}
                            onChange={(e) =>
                              setReferralCommission(e.target.value)
                            }
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="Referral Commission"
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={8}>Referral Commission Loss</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            value={lossReferralCommission}
                            onChange={(e) =>
                              setLReferralCommission(e.target.value)
                            }
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="Referral Commission"
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={8}>Commission Range1 (%)</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            value={commissionRange1}
                            onChange={(e) =>
                              setCommissionRange1(e.target.value)
                            }
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="Commission Range1"
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={8}>Commission Range2 (%)</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            value={commissionRange2}
                            onChange={(e) =>
                              setCommissionRange2(e.target.value)
                            }
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="Commission Range2"
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={8}>Commission Range3 (%)</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            value={commissionRange3}
                            onChange={(e) =>
                              setCommissionRange3(e.target.value)
                            }
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="Commission Range3"
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>
                          <button type="submit" className="btn btn-dark">
                            submit
                          </button>
                        </Col>
                      </Row>
                    </Container>
                  </Card.Body>
                </Card>
              </div>
              <div className="form-group col-md-6">
                <Card>
                  <Card.Body>
                    <h4 className="dashboard_small_heading_blue">
                      Other Game Setting
                    </h4>
                    <Container>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Game Search</Col>
                        <Col sm={2}>
                          {" "}
                          <ReactSwitch
                            checked={checkedGame}
                            onChange={handleChangeGame}
                            style={{ display: "none" }}
                          />
                        </Col>
                      </Row>
                      <Row
                                              style={{ marginRight: "4.25rem", marginTop: "10px" }}
                                            >
                                              <Col sm={6}>Bots</Col>
                                              <Col sm={2}>
                                                {" "}
                                                <ReactSwitch
                                                  checked={isBots}
                                                  onChange={handleBots}
                                                  style={{ display: "none" }}
                                                />
                                              </Col>
                                            </Row>
                                              <Row style={{ marginRight: "4.25rem", marginTop: "10px" }} >
                                              <Col sm={6}>Bots Count</Col>
                                              <Col sm={1}>
                                                <input
                                                  type="number"
                                                  value={totalBotsCount}
                                                  onChange={(e) => settotalBotsCount(e.target.value)}
                                                  style={{
                                                    border: "1px Solid Black",
                                                    borderRadius: "3px",
                                                  }}
                                                  placeholder="Bots"
                                                />
                                              </Col>
                                            </Row>

                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Game TDS</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            value={gameTDS}
                            onChange={(e) => setGameTDS(e.target.value)}
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="gameTDS"
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Game Limit Min</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            value={gameLimitMin}
                            onChange={(e) => setGameLImitMin(e.target.value)}
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="Limit Min"
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Game Limit Max</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            value={gameLimitMax}
                            onChange={(e) => setGameLImitMax(e.target.value)}
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="Limit Max"
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Conflict Red-zone-Time</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            value={conflictRedTime}
                            onChange={(e) => setconflictRedTime(e.target.value)}
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="Minutes"
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Withdraw Red-zone-Time</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            value={withdrawRedTime}
                            onChange={(e) => setwithdrawRedTime(e.target.value)}
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="Minutes"
                          />
                        </Col>
                      </Row>
                        <Row
                        style={{ marginRight: "4.25rem", marginTop: "20px" }}
                      >
                        <Col sm={6}>Room Code</Col>
                        <Col sm={2}>
                          {" "}
                          <ReactSwitch
                            checked={checkedRoomCode}
                            onChange={handleChangeRoomCode}
                            style={{ display: "none" }}
                          />
                        </Col>
                      </Row>

                    
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>
                          <button type="submit" className="btn btn-dark">
                            submit
                          </button>
                        </Col>
                      </Row>
                    </Container>
                  </Card.Body>
                </Card>
              </div>
            </div>
            <div className="form-row">
            <div className="form-group col-md-6">
                <Card>
                  <Card.Body>
                    <h4 className="dashboard_small_heading_blue">Deposit</h4>
                    <Container>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Enable</Col>
                        <Col sm={2}>
                          {" "}
                          <ReactSwitch
                            checked={checkedDeposit}
                            onChange={handleChangeDeposit}
                            style={{ display: "none" }}
                          />
                        </Col>
                      </Row>

                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Deposit Limit Min</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            value={depositlimitMin}
                            onChange={(e) => setDepositMin(e.target.value)}
                            placeholder="Deposit Limit Min"
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Deposit Limit Max</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            value={depositlimitMax}
                            onChange={(e) => setDepositMax(e.target.value)}
                            placeholder="Deposit Limit Max"
                          />
                        </Col>
                      </Row>
                      
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>
                          <button type="submit" className="btn btn-dark">
                            submit
                          </button>
                        </Col>
                      </Row>
                    </Container>
                  </Card.Body>
                </Card>
              </div>
            {/* <div className="form-group col-md-6">
                <Card>
                  <Card.Body>
                    <h4 className="dashboard_small_heading_blue">New User Deposit</h4>
                    <Container>
                    <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>New User Deposit Amount</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            value={newUserDeposit}
                            onChange={(e) => setnewDeposit(e.target.value)}
                            placeholder="Deposit Amount"
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>
                          <button type="submit" className="btn btn-dark">
                            submit
                          </button>
                        </Col>
                      </Row>
                    </Container>
                  </Card.Body>
                </Card>
              </div> */}
            </div>

            <div className="form-row">
            <div className="form-group col-md-6">
                <Card>
                  <Card.Body>
                    <h4 className="dashboard_small_heading_blue">Withdrawal</h4>
                    <Container>
                    
                     
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Withdrawal Limit Upi Min</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            value={withdrawalLimitMinUpi}
                            onChange={(e) => setWithdrawalUpiMin(e.target.value)}
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="Upi Min"
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Withdrawal Limit Upi Max</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            value={withdrawalLimitMaxUpi}
                            onChange={(e) => setWithdrawalUpiMax(e.target.value)}
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="Upi Max"
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Withdrawal Limit Bank Min</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            value={withdrawalLimitMinBank}
                            onChange={(e) => setWithdrawalBankMin(e.target.value)}
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="Bank Min"
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Withdrawal Limit Bank Max</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            value={withdrawalLimitMaxBank}
                            onChange={(e) => setWithdrawalBankMax(e.target.value)}
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="Bank Max"
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Withdrawal Limit QR Min</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            value={withdrawQrLimitMin}
                            onChange={(e) => setWithdrawalQrMin(e.target.value)}
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="QR Min"
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Withdrawal Limit QR Max</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            value={withdrawQrLimitMax}
                            onChange={(e) => setWithdrawalQrMax(e.target.value)}
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="QR Max"
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}> Auto Withdrawal Limit</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            value={autoWithdrawalLimitMax}
                            onChange={(e) =>
                              setautoWithdrawalMax(e.target.value)
                            }
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="Auto Withdrawal Limit"
                          />
                        </Col>
                      </Row>
                    
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>
                          <button type="submit" className="btn btn-dark">
                            submit
                          </button>
                        </Col>
                      </Row>
                    </Container>
                  </Card.Body>
                </Card>
              </div>
              <div className="form-group col-md-6">
                <Card>
                  <Card.Body>
                    <h4 className="dashboard_small_heading_blue">Withdrawal</h4>
                    <Container>
                     
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Upi Withdrawal</Col>
                        <Col sm={2}>
                          <ReactSwitch
                            checked={checkedUpiWithdrawal}
                            onChange={handleChangeUpiWithdrawal}
                            style={{ display: "none" }}
                          />
                        </Col>
                      </Row>
                     
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Bank Withdrawal</Col>
                        <Col sm={2}>
                          <ReactSwitch
                            checked={checkedBankWithdrawal}
                            onChange={handleChangeBankWithdrawal}
                            style={{ display: "none" }}
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Qr Withdrawal</Col>
                        <Col sm={2}>
                          <ReactSwitch
                            checked={checkedQrWithdrawal}
                            onChange={handleChangeQrWithdrawal}
                            style={{ display: 'none' }}
                          />
                        </Col>
                      </Row>

                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Withdrawal Limit Min</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            value={withdrawalLimitMin}
                            onChange={(e) => setWithdrawalMin(e.target.value)}
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="Withdrawa Limit Min"
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Withdrawal Limit Max</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            value={withdrawalLimitMax}
                            onChange={(e) => setWithdrawalMax(e.target.value)}
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="Commission Range1"
                          />
                        </Col>
                      </Row>

                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Withdrwal Time</Col>
                        <Col sm={1}>
                          <input
                            type="number"
                            onChange={(e) => {
                              const minutes = parseFloat(e.target.value);
                              const milliseconds = minutes * 60 * 1000; // Convert hours to milliseconds
                              setWithdrawTime(milliseconds);
                            }}
                            value={withdrawTime / (60 * 1000)} // Display in hours
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="Withdrawal Time"
                          />
                        </Col>
                      </Row>
                    
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>
                          <button type="submit" className="btn btn-dark">
                            submit
                          </button>
                        </Col>
                      </Row>
                    </Container>
                  </Card.Body>
                </Card>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group col-md-6">
                <Card>
                  <Card.Body>
                    <h4 className="dashboard_small_heading_blue">Support</h4>
                    <Container>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Support Mail</Col>
                        <Col sm={1}>
                          <input
                            type="Email"
                            value={supportMail}
                            onChange={(e) => setSupportMail(e.target.value)}
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="Email"
                          />
                        </Col>
                      </Row>
                      {/* <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Support Instagram</Col>
                        <Col sm={1}>
                          <input
                            type="url"
                            value={supportInstagram}
                            onChange={(e) =>
                              setSupportInstagram(e.target.value)
                            }
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="Enter Url"
                          />
                        </Col>
                      </Row> */}
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Support Telegram</Col>
                        <Col sm={1}>
                          <input
                            type="url"
                            value={supportTelegram}
                            onChange={(e) => setSupportTelegram(e.target.value)}
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="Enter Url"
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Support WhatsApp</Col>
                        <Col sm={1}>
                          <input
                            type="url"
                            value={supportWhatsapp}
                            onChange={(e) => setSupportWhatsapp(e.target.value)}
                            style={{
                              border: "1px Solid Black",
                              borderRadius: "3px",
                            }}
                            placeholder="Enter Url"
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Chat Support</Col>
                        <Col sm={2}>
                          {" "}
                          <ReactSwitch
                            checked={checkedSupport}
                            onChange={handleChangeSupport}
                            style={{ display: "none" }}
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>
                          <button type="submit" className="btn btn-dark">
                            submit
                          </button>
                        </Col>
                      </Row>
                    </Container>
                  </Card.Body>
                </Card>
              </div>
              <div className="form-group col-md-6">
                <Card>
                  <Card.Body>
                    <h4 className="dashboard_small_heading_blue">Other Settings</h4>
                    <Container>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>User Login</Col>
                        <Col sm={2}>
                          <ReactSwitch
                      checked={checkedLogin}
                      onChange={handleChangeLogin}
                      style={{ display: "none" }}
                    />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>User SignUp</Col>
                        <Col sm={2}>
                        <ReactSwitch
                      checked={checkedsignup}
                      onChange={handleChangeSignUp}
                      style={{ display: "none" }}
                    />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Site Maintenance</Col>
                        <Col sm={2}>
                        <ReactSwitch
                      checked={checkedMaintenance}
                      onChange={handleChangeMaintenance}
                      style={{ display: "none" }}
                    />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Online Kyc</Col>
                        <Col sm={2}>
                        <ReactSwitch
                      checked={onlineKYC}
                      onChange={handleChangeonlineKYC}
                      style={{ display: "none" }}
                    />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Ofline Kyc</Col>
                        <Col sm={2}>
                        <ReactSwitch
                      checked={offlineKYC}
                      onChange={handleChangeofflineKYC}
                      style={{ display: "none" }}
                    />
                        </Col>
                      </Row>
                     
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>
                          <button type="submit" className="btn btn-dark">
                            submit
                          </button>
                        </Col>
                      </Row>
                    </Container>
                  </Card.Body>
                </Card>
              </div>
              <div className="form-group col-md-6">
                <Card>
                  <Card.Body>
                    <h4 className="dashboard_small_heading_blue">LUDO MANAGE</h4>
                    <Container>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Ludo Classic</Col>
                        <Col sm={2}>
                          <ReactSwitch
                      checked={isLudokingClassic}
                      onChange={handleLudoClassic}
                      style={{ display: "none" }}
                    />
                        </Col>
                      </Row>
                      {/* <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Tijjr Classic</Col>
                        <Col sm={2}>
                          <ReactSwitch
                      checked={tijjrclassic}
                      onChange={handleTijjrClassic}
                      style={{ display: "none" }}
                    />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Tijjr Ludo</Col>
                        <Col sm={2}>
                        <ReactSwitch
                      checked={tijjrLudo}
                      onChange={handleTijjrLudo}
                      style={{ display: "none" }}
                    />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Tijjr-One-Goti</Col>
                        <Col sm={2}>
                        <ReactSwitch
                      checked={tijjrOneGoti}
                      onChange={handleTijjrOneGoti}
                      style={{ display: "none" }}
                    />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Tijjr-Two-Goti</Col>
                        <Col sm={2}>
                        <ReactSwitch
                      checked={tijjrTwoGoti}
                      onChange={handleTijjrTwoGoti}
                      style={{ display: "none" }}
                    />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>Tijjr-Speed-Ludo</Col>
                        <Col sm={2}>
                        <ReactSwitch
                      checked={tijjrSpeedLudo}
                      onChange={handleTijjrSpeed}
                      style={{ display: "none" }}
                    />
                        </Col>
                      </Row> */}
                     
                      <Row
                        style={{ marginRight: "4.25rem", marginTop: "10px" }}
                      >
                        <Col sm={6}>
                          <button type="submit" className="btn btn-dark">
                            submit
                          </button>
                        </Col>
                      </Row>
                    </Container>
                  </Card.Body>
                </Card>
              </div>
            </div>

            <h4 className="my-3 dashboard_small_heading_dark">Other</h4>

            <div className="form-row">
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Website Title</label>
                <input
                  className="form-control"
                  type="text"
                  value={WebTitle}
                  onChange={(e) => setWebTitle(e.target.value)}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Website Name</label>
                <input
                  className="form-control"
                  type="text"
                  value={WebsiteName}
                  onChange={(e) => setWebName(e.target.value)}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Commpany Name</label>
                <input
                  className="form-control"
                  type="text"
                  value={CompanyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                />
              </div>

              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Commpany Address</label>
                <input
                  className="form-control"
                  type="text"
                  value={CompanyAddress}
                  onChange={(e) => setCompanyAddress(e.target.value)}
                />
              </div>

              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Support Mobile</label>
                <input
                  className="form-control"
                  type="text"
                  value={CompanyMobile}
                  onChange={(e) => setCompanyMobile(e.target.value)}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Logo</label>
                <input
                  className="form-control"
                  type="file"
                  name="Logo"
                  id="Logo"
                />
              </div>
            </div>

         

            <div className="form-row">
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">version</label>

                <input
                  className="form-control"
                  type="text"
                  value={version}
                  onChange={(e) => setVersion(e.target.value)}
                />
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Site Maintenance Message</label>

                <input
                  className="form-control"
                  type="text"
                  value={maintenence_msg}
                  onChange={(e) => setMaintenence_msg(e.target.value)}
                  placeholder="Type Message"
                />
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Site Page Message</label>

                <input
                  className="form-control"
                  type="text"
                  value={site_message}
                  onChange={(e) => setSite_message(e.target.value)}
                  placeholder="Type Message"
                />
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Ludo Classic Message</label>

                <input
                  className="form-control"
                  type="text"
                  value={ludoClassicAutoMsg}
                  onChange={(e) => setLudoClassicAutoMsg(e.target.value)}
                  placeholder="Type Message"
                />
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Ludo Classic Battle Message</label>

                <input
                  className="form-control"
                  type="text"
                  value={ludoClassicAutobattleMsg}
                  onChange={(e) => setLudoClassicAutobattleMsg(e.target.value)}
                  placeholder="Type Message"
                />
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Ludo Manual Message</label>

                <input
                  className="form-control"
                  type="text"
                  value={site_viewManual}
                  onChange={(e) => setSite_viewManual(e.target.value)}
                  placeholder="Type Message"
                />
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Ludo Manual Battle Message</label>

                <input
                  className="form-control"
                  type="text"
                  value={site_viewManualBattle}
                  onChange={(e) => setSite_viewManualBattle(e.target.value)}
                  placeholder="Type Message"
                />
              </div>

              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Deposit On MSG</label>

                <input
                  className="form-control"
                  type="text"
                  value={deposit_message_on}
                  onChange={(e) => setdeposit_message_on(e.target.value)}
                  placeholder="Type Message"
                />
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Deposit Close MSG</label>

                <input
                  className="form-control"
                  type="text"
                  value={deposit_message}
                  onChange={(e) => setDeposit_message(e.target.value)}
                  placeholder="Type Message"
                />
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Withdraw On MSG</label>

                <input
                  className="form-control"
                  type="text"
                  value={withdraw_message}
                  onChange={(e) => setWithdraw_message(e.target.value)}
                  placeholder="Type Message"
                />
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="WebsiteName">Withdraw Off MSG</label>

                <input
                  className="form-control"
                  type="text"
                  value={withdraw_messageOff}
                  onChange={(e) => setWithdraw_messageOff(e.target.value)}
                  placeholder="Type Message"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-4">
                <button type="submit" className="btn btn-dark">
                  submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* <Gateway /> */}
    </>
  );
};
